import $ from 'jquery';
import { CommentsCollection } from 'models/CommentsCollection';
import CommentsContainerView from 'ui/comments/home/comments-container-view';

export default {
    init() {
        $(document).ready(() => {
            const commentsCollection = new CommentsCollection();
            const commentsContainerView = new CommentsContainerView(commentsCollection);
            commentsContainerView.render();
        });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/home/index.js